var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m23.277 3.127 4.389 4.092a2 2 0 0 1 .098 2.827l-16.12 17.288a1 1 0 0 1-.607.31l-7.151.902a.2.2 0 0 1-.225-.21l.402-7.196a1 1 0 0 1 .267-.626L20.45 3.226a2 2 0 0 1 2.828-.099z",
    stroke: "#6B47F5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.06 26.85c-1.661-.638-3.102-1.525-4.32-2.662-1.22-1.136-2.211-2.517-2.975-4.141v0",
    stroke: "#6B47F5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17.723 6.151 7.313 6.82-7.313-6.82z",
    stroke: "#6B47F5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.06 23.89 9.816-10.515",
    stroke: "#6B47F5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/icon_pencil.120245322198e8365f0a16222956a633.svg";
export { ForwardRef as ReactComponent };